import Vector from "./Vector";

/**
 * @typedef { import("./Polygon").default } Polygon
 * @typedef { import("./TriggerSet").default } TriggerSet
 */
export default class Component {

    /** @param {{ polygons: Polygon[], trigger: TriggerSet, element }} param0 */
    constructor({ polygons, trigger, element }) {
        this.polygons = polygons || [];
        this.trigger = trigger;
        this.element = element;

        this.calculateMeasurements();
    }

    calculateMeasurements() {
        let totalX = 0;
        let totalY = 0;
        const frequency = this.polygons.length;

        for(const polygon of this.polygons) {
            totalX += polygon.center.x;
            totalY += polygon.center.y;
        }

        this.center = new Vector(
            totalX / frequency,
            totalY / frequency  
        );
    }


    setStyle(style) {
        for(const polygon of this.polygons) polygon.setStyle(style);
    }
}